import React from 'react';
import Trustpilot from './AsyncTrustpilot';
import { Experiment } from '../Experiment';

function TrustPilotEU() {
  return (
    <Experiment name="HA_PTA_HP_TrustPilotEUBrands">
      {value => (value === 1 && <Trustpilot />)}
    </Experiment>
  );
}

export default TrustPilotEU;
